import appStore from '@/store';

export const dispatchGetDraftsCount = async (): Promise<void> => {
  await appStore.dispatch('getDraftsCount');
};
export const dispatchGetMeetingsCount = async (): Promise<void> => {
  await appStore.dispatch('getMeetingsCount');
};
export const dispatchGetRetentionCount = async (): Promise<void> => {
  await appStore.dispatch('getRetentionCount');
};
// For flows that can move a recording in or out of the Retention page (SNAP-2438)
export const dispatchGetRetentionCountIfEnabled = async (): Promise<void> => {
  if (!appStore.state.company?.retention?.enabled) return;
  await dispatchGetRetentionCount();
};
export const dispatchGetPersonalArticlesCount = async (): Promise<void> => {
  await appStore.dispatch('getPersonalArticlesCount');
};
export const dispatchDisableOcrMode = async (): Promise<void> => {
  await appStore.dispatch('disableOcrMode');
};
export const dispatchEnableOcrMode = async (): Promise<void> => {
  await appStore.dispatch('enableOcrMode');
};
